export const GOOGLE_GROUP_NAMES: { [key: string]: string } = {
  "teamtestsubmissions@luminorrisk.com": "Team Test",
  "teamtiosubmissions@luminorrisk.com": "Team Tio",
  "teamterrysubmissions@luminorrisk.com": "Team Terry",
  "teamgaineysubmissions@luminorrisk.com": "Team Gainey",
  "teamwilliamssubmissions@luminorrisk.com": "Team Williams",
  "teambrottsubmissions@luminorrisk.com": "Team Brott",
  "teamshermansubmissions@luminorrisk.com": "Team Sherman",
  "teamcoopersubmissions@luminorrisk.com": "Team Cooper",
  "teamcurciosubmissions@luminorrisk.com": "Team Curcio",
  "teamdelucasubmissions@luminorrisk.com": "Team Deluca",
  "teamwoodsubmissions@luminorrisk.com": "Team Wood",
  "teamcorleysubmissions@luminorrisk.com": "Team Corley",
  "teamalpersubmissions@luminorrisk.com": "Team Alper",
  "teamdanilesubmissions@luminorrisk.com": "Team Danile",
  "teamlallysubmissions@luminorrisk.com": "Team Lally",
  "teamyukosubmissions@luminorrisk.com": "Team Yuko",
  "teamhendersontollandsubmissions@luminorrisk.com": "Team Henderson Tolland",
  "teamptollandsubmissions@luminorrisk.com": "Team P. Tolland",
  "teamhoppersubmissions@luminorrisk.com": "Team Hopper",
  "teamreasamuelssubmissions@luminorrisk.com": "Team Rea Samuels",
  "teamflemmingsubmissions@luminorrisk.com": "Team Flemming",
  "teamwolfsubmissions@luminorrisk.com": "Team Wolf",
  "teambrennansubmissions@luminorrisk.com": "Team Brennan",
  "teamjjmorrowsubmissions@luminorrisk.com": "Team JJ Morrow",
  "teamstratissubmissions@luminorrisk.com": "Team Stratis",
  "teamjadachdipietrosubmissions@luminorrisk.com": "Team Jadach DiPietro",
  "teamforzasubmissions@luminorrisk.com": "Team Forza",
  "teampurdysubmissions@luminorrisk.com": "Team Purdy",
  "teamrobinsonsubmissions@luminorrisk.com": "Team Robinson",
  "teamplasceniasubmissions@luminorrisk.com": "Team Plascenia",
  "teamadairsubmissions@luminorrisk.com": "Team Adair",
  "teamrozzisubmissions@luminorrisk.com": "Team Rozzi",
  "teamnovaksubmissions@luminorrisk.com": "Team Novak",
  "teamshearerhasansubmissions@luminorrisk.com": "Team Shearer Hasan",
  "teamsparlingsubmissions@luminorrisk.com": "Team Sparling",
  "teammccormacksubmissions@luminorrisk.com": "Team McCormack",
  "teamgattoomarragreiccoberlinersubmissions@luminorrisk.com":
    "Team Gatto OMarra Greicco Berliner",
  "teamgoldmansubmissions@luminorrisk.com": "Team Goldman",
  "teamkasbeersubmissions@luminorrisk.com": "Team Kasbeer",
  "teamscottsubmissions@luminorrisk.com": "Team Scott",
  "teamhenrydarbysubmissions@luminorrisk.com": "Team Henry Darby",
  "teamdresssubmissions@luminorrisk.com": "Team Dress",
  "teamtimminssubmissions@luminorrisk.com": "Team Timmins",
  "teammossmcgeesubmissions@luminorrisk.com": "Team Moss McGee",
  "teamlotfeyflanagansubmissions@luminorrisk.com": "Team Lotfey Flanagan",
  "teamhumemurphysubmissions@luminorrisk.com": "Team Hume Murphy",
  "teamtroisisubmissions@luminorrisk.com": "Team Troisi",
  "teamjohnstonsubmissions@luminorrisk.com": "Team Johnston",
  "teamwhitesubmissions@luminorrisk.com": "Team White",
  "teamwelchsubmissions@luminorrisk.com": "Team Welch",
  "teamgiordanosubmissions@luminorrisk.com": "Team Giordano",
};
